import React from "react";
import "./ErrorMsg.scss";

// eslint-disable-next-line react/prop-types
const ErrorMsg = ({ txt }) => {
	return <p className="error-msg">{txt}</p>;
};

export default ErrorMsg;
